import * as React from 'react';

import OrderRefundStatus, {
	Props as OrderRefundStatusProps
} from '../../../../Refund/Components/OrderRefundStatus/OrderRefundStatus';
import { useTheme } from '../../../../theme';

type Props = Omit<OrderRefundStatusProps, 'status'>;

const ParentOrderStatus: React.FC<Props> = props => {
	const { ParentOrderStatus: theme } = useTheme('Checkout');

	return <OrderRefundStatus {...props} className={theme.container} status={null} />;
};

export default ParentOrderStatus;
